const Telegram = () => {
    return (
        <div className="flex cursor-pointer">
            <a href="https://t.me/Explosive0105" target={"_blank"} rel="noreferrer">
                <img src={'/logo-telegram.svg'} alt="Telegram"className="w-7" />
            </a>
        </div>
    )
}

export default Telegram

